import React from 'react';
import { Box, Typography } from '@mui/material';
import './SlaCard.css';

const SlaCard = ({ title, value }) => (
  <Box className="slaCard">
    <Typography className="slaCard__title">{title}</Typography>
    <Typography className="slaCard__value">{value}</Typography>
  </Box>
);

export default SlaCard;
